export const issueConstants = {

  GETALL_REQUEST: 'ISSUES_GETALL_REQUEST',
  GETALL_SUCCESS: 'ISSUES_GETALL_SUCCESS',
  GETALL_FAILURE: 'ISSUES_GETALL_FAILURE',

  DELETE_ISSUE_REQUEST: 'DELETE_ISSUE_REQUEST',
  DELETE_ISSUE_SUCCESS: 'DELETE_ISSUE_SUCCESS',
  DELETE_ISSUE_FAILURE: 'DELETE_ISSUE_FAILURE',

  UPDATE_ISSUE_REQUEST: 'UPDATE_ISSUE_REQUEST',
  UPDATE_ISSUE_SUCCESS: 'UPDATE_ISSUE_SUCCESS',
  UPDATE_ISSUE_FAILURE: 'UPDATE_ISSUE_FAILURE',

  UPDATE_ISSUE_STATUS_REQUEST: 'UPDATE_ISSUE_STATUS_REQUEST',
  UPDATE_ISSUE_STATUS_SUCCESS: 'UPDATE_ISSUE_STATUS_SUCCESS',
  UPDATE_ISSUE_STATUS_FAILURE: 'UPDATE_ISSUE_STATUS_FAILURE',

  START_DATE_CHANGE: 'START_DATE_CHANGE',
  END_DATE_CHANGE: 'END_DATE_CHANGE'
}



// WEBPACK FOOTER //
// ./src/constants/issue.constants.js